"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _moment = _interopRequireDefault(require("moment"));
var _chart = _interopRequireDefault(require("cccisd-icons/chart"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReportHeader = function ReportHeader(props) {
  var fakeData = props.isPreview ? {
    header: {
      startDate: '2020-01-13',
      endDate: '2020-02-29',
      reportCreatedDate: 'March 01, 2020',
      groupLeaderName: 'Some Person',
      numGroups: 5,
      numParticipants: 28
    },
    groupIds: [0, 1, 2, 3, 4]
  } : null;
  var _props$settings = props.settings,
    _props$settings$heade = _props$settings.header,
    title = _props$settings$heade.title,
    subtitle = _props$settings$heade.subtitle,
    description = _props$settings$heade.description,
    groupLeaderText = _props$settings$heade.groupLeaderText,
    reportingPeriodText = _props$settings$heade.reportingPeriodText,
    createdDateText = _props$settings$heade.createdDateText,
    numGroupsText = _props$settings$heade.numGroupsText,
    numParticipantsText = _props$settings$heade.numParticipantsText,
    colors = _props$settings.colors;
  if (colors && colors.primary) {
    colors.primary = (0, _cccisdColorPicker.getColor)(colors.primary);
  }
  var selectedIds = props.filters.groupIds ? props.filters.groupIds : fakeData.groupIds;
  var getHeaderValues = function getHeaderValues() {
    var data = props.data;
    var numGroups = selectedIds.length;
    var filteredGroups = data.groups.treatmentGroupList.filter(function (tg) {
      return selectedIds.includes(tg.group.groupId);
    });
    var numParticipants = 0;
    for (var i = 0; i < filteredGroups.length; i++) {
      numParticipants += filteredGroups[i].childRoles.participantCount;
    }
    var groupLeaders = [];
    if (props.individuals) {
      var treatmentGroup = props.data.groups.treatmentGroupList.filter(function (tgl) {
        return tgl.childRoles.participantList.find(function (pl) {
          return selectedIds.includes(pl.pawn.pawnId);
        });
      });
      var individualName = treatmentGroup[0].childRoles.participantList.find(function (pl) {
        return selectedIds.includes(pl.pawn.pawnId);
      });
      groupLeaders = [individualName.fields.participantId];
    }
    if (filteredGroups.length === 1 && !props.individuals) {
      if (filteredGroups[0].childRoles.metricspawn.assignmentProgressSummary.caregiverFacilitatorNames && filteredGroups[0].childRoles.metricspawn.assignmentProgressSummary.childFacilitatorNames) {
        filteredGroups[0].childRoles.metricspawn.assignmentProgressSummary.caregiverFacilitatorNames.forEach(function (cf) {
          return groupLeaders.push(cf.value);
        });
        filteredGroups[0].childRoles.metricspawn.assignmentProgressSummary.childFacilitatorNames.forEach(function (cf) {
          return groupLeaders.push(cf.value);
        });
        groupLeaders = (0, _uniq2["default"])(groupLeaders.filter(function (d) {
          return d !== null;
        })).map(function (str) {
          return str.replace(/[, ]+/g, ' ').trim();
        });
      }
    } else if (filteredGroups.length !== 1 && !props.individuals) {
      groupLeaders = ['Multiple Groups'];
    }
    return {
      numGroups: numGroups,
      numParticipants: numParticipants,
      groupLeaders: groupLeaders
    };
  };
  var _renderGroupFilters = function _renderGroupFilters() {
    if (!props.individuals) {
      var groups = selectedIds;
      var getGroupName = function getGroupName(id) {
        var findGroup = props.data.groups.treatmentGroupList.find(function (tg) {
          return tg.group.groupId === Number(id);
        });
        return findGroup ? findGroup.group.label : '';
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, groups.map(function (group) {
        var groupName = getGroupName(group);
        if (groupName !== '') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: group,
            className: _style["default"].groupFilter,
            style: colors ? {
              border: "1px solid ".concat(colors.primary),
              color: colors.primary
            } : {}
          }, groupName);
        }
        return null;
      }));
    }
    return null;
  };
  var header = getHeaderValues();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerTop
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topLeft,
    style: colors ? {
      backgroundColor: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerTitle
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topCenter,
    style: colors ? {
      backgroundColor: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topCenterHighlight,
    style: colors ? {
      backgroundColor: (0, _color["default"])(colors.primary).lighten(0.1)
    } : {}
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topRight,
    style: colors ? {
      color: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, reportingPeriodText, " "), props.filters.startDate && props.filters.endDate ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.filters.startDate, " to ", props.filters.endDate) : 'None specified'), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, createdDateText, " "), (0, _moment["default"])(new Date()).format('MMMM Do YYYY')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerBot
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].botLeft
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].description,
    style: colors ? {
      color: colors.primary
    } : {}
  }, description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].botCenter,
    style: colors ? {
      backgroundColor: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].botCenterShadow,
    style: colors ? {
      backgroundColor: (0, _color["default"])(colors.primary).darken(0.1)
    } : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].botCenterHighlight,
    style: colors ? {
      backgroundColor: (0, _color["default"])(colors.primary).darken(0.05)
    } : {}
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].botRight,
    style: colors ? {
      backgroundColor: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '18px'
    }
  }, subtitle)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].subheader,
    style: colors ? {
      color: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].subheaderText
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: props.individuals ? {
      fontWeight: 'bold',
      fontSize: '1.4em'
    } : {
      fontWeight: 'bold'
    }
  }, groupLeaderText, ' '), /*#__PURE__*/_react["default"].createElement("span", {
    style: props.individuals ? {
      fontSize: '1.4em'
    } : {}
  }, header.groupLeaders.join(', '))), !props.individuals && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, numGroupsText, " "), header.numGroups), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, numParticipantsText, " "), header.numParticipants))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].subheaderIcon,
    style: props.individuals ? {
      fontSize: '2em'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement(_chart["default"], null))), !props.individuals && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].filters
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].filtersText,
    style: colors ? {
      color: colors.primary
    } : {}
  }, "Current Report Includes:"), _renderGroupFilters()));
};
var _default = exports["default"] = ReportHeader;